/**
 * @generated SignedSource<<6d8b0b03b818499a87e33f9fa109cb6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type colorField_updateWorkItemFieldsActionRenderer$data = {
  readonly color: {
    readonly colorKey: string | null;
  } | null;
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentType": "colorField_updateWorkItemFieldsActionRenderer";
};
export type colorField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: colorField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"colorField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "colorField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraColor",
      "kind": "LinkedField",
      "name": "color",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorKey"
        }
      ]
    }
  ],
  "type": "JiraColorField"
};

(node as any).hash = "70826ff7f56c2f65c9e1a5f68022b7ab";

export default node;
